import React from 'react';

const IconLogo = ({ size = 84, color = 'currentColor' }) => (
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 100 100"
    width={size}
    height={size}
    stroke={color}
    fill={color}>
    <defs>
      <linearGradient id="accent" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="var(--green)" />
        <stop offset="100%" stopColor="var(--blue)" />
      </linearGradient>
    </defs>
    <g>
      {/* Outer rectangle */}
      <rect
        x="8"
        y="8"
        width="84"
        height="84"
        rx="18"
        ry="18"
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
      />

      {/* Inner icon */}
      <g className="icon-inner">
        <path
          d="M35 65 C35 52 65 52 65 40 C65 32 58 28 50 28 C42 28 36 32 34 39"
          fill="none"
          stroke="url(#accent)"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <circle cx="50" cy="68" r="3" fill="currentColor" />
      </g>
    </g>
  </svg>
);

export default IconLogo;
